import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';
import { SpacingProps } from '@sdk/components/ui/spacing/Spacing';

export const PurchaseViewContainer = styled(Row)<{ isSingleColumn: boolean } & SpacingProps>`
  ${({ isSingleColumn }) =>
    isSingleColumn
      ? `
    flex-direction: column;
    align-items: center;
  `
      : ''}
`;
